import { useState, useEffect } from "react";
import { TokenVerificationLoggedin, ScreenView } from "../../utils/tokenVerify";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import DashboardV2Main from "./DashboardV2Main";

const DashboardV2 = () => {
    const [role, setRole] = useState('');

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        // BlockAdmin()

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setRole(checkRole)

        }


    }, [])

    return (
        <>
            <DashboardV2Main role={role} />

        </>

    );
};

export default DashboardV2;